export const COLLAPSIBLE_MENU_EXPAND_TIMEOUT = 500